import React from 'react'
import {useCopyLeaderBoardFilter} from '@hook/useLeaderBoardFilter'
import LeaderboardHeaderContainer from '@feature/leaderboard/pages/ScreenCopyLeader/LeaderHeaders/LeaderboardHeaderContainer'
import dynamic from 'next/dynamic'
import Spinner from '@component/Spinner/Spinner'

interface IProps {
    className?: string
}

const LeaderboardScreenCopyTableContent = dynamic(
    import('@feature/leaderboard/pages/ScreenCopyLeader/LeaderboardScreenCopyTableContent'),
    {
        ssr: false,
        loading: e => <Spinner visible={e?.isLoading} className={'mt-[30px] mx-auto'} />,
    },
)

const LeaderboardScreenCopyTableContainer: React.FC<IProps> = ({className}) => {
    const {copyFilter, setCopyFilter} = useCopyLeaderBoardFilter()
    const {filter: isFilterFavorite} = copyFilter

    return (
        <div data-cy={'leaderboard_table_copyleader'} className={`${className}`}>
            <LeaderboardHeaderContainer isFilterFavorite={isFilterFavorite} />
            <LeaderboardScreenCopyTableContent setCopyFilter={setCopyFilter} copyFilter={copyFilter} />
        </div>
    )
}

export default LeaderboardScreenCopyTableContainer
